import { type ReactNode } from 'react';
import { cn } from '../../lib/utils.js';

export function Field({
  label,
  htmlFor,
  error,
  hint,
  children,
}: {
  label: string;
  htmlFor: string;
  error?: string | undefined;
  hint?: string | undefined;
  children: ReactNode;
}) {
  return (
    <div className="space-y-1.5">
      <label htmlFor={htmlFor} className="text-body font-medium text-[var(--ink-700)]">
        {label}
      </label>
      {children}
      {hint && !error && <p className="text-meta text-[var(--fg-faint)]">{hint}</p>}
      {error && <p className="text-meta text-red-700">{error}</p>}
    </div>
  );
}

export function FormActions({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('flex items-center justify-end gap-2 pt-2', className)}>{children}</div>
  );
}
